import axios from "axios";
import { WEBSERVICE } from "../CoreDataService";

/**
 * Checks the number of OTPs sent to the given phone/country.
 * @param {Object} payload { phone, countryCode, userId, uuid }
 * @param {string} param The URL parameter (action)
 */
export const checkMobileOtpCount = async (payload, param) => {
  try {
    const response = await axios.post(
      `${WEBSERVICE}user/checkMobileOtp/${param}`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data; 
  } catch (error) {
    console.error("Error fetching OTP count:", error);
    return { totalcount: 0 }; 
  }
};

/**
 * Sends the mobile OTP.
 * @param {Object} payload { phone, countryCode, userId, uuid, gRecaptchaResponse }
 * @param {string} param The URL parameter (e.g., 'login', 'registration', 'changephone')
 */
export const sendMobileOtp = async (payload, param) => {
  try {
    const response = await axios.post(
      `${WEBSERVICE}user/sendMobileOtp/${param}`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending mobile OTP:", error);
    throw error;
  }
};
